// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1jR34","amount":"Amount_amount__1TsWo","tip":"Amount_tip__1_abZ","tipHeader":"Amount_tipHeader__2PTik","tipsWrap":"Amount_tipsWrap__kHsWv"};